import { c as _c } from "react/compiler-runtime";
import { IconAlertInfoOutline18 } from "nucleo-ui-outline-18";
import { cn } from "@/lib/utils";
export function IncentiveHowItWorks(t0) {
  const $ = _c(6);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("border-ds-border-default bg-ds-surface-card shadow-ds-soft rounded-xl border p-5", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-ds-text-primary mb-2 flex items-center gap-2 text-sm font-semibold"><IconAlertInfoOutline18 className="text-ds-text-muted h-4 w-4" /> How it works</div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ul className="text-ds-text-muted list-disc space-y-1 pl-5 text-sm"><li>CU (Compute Units) power workflow runs and AI tasks</li><li>AI Credits unlock advanced AI model access</li><li>Rewards are credited instantly upon verification</li><li>Each task can be claimed once per organization</li></ul>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}